// Avatar initials for a mailbox counterpart (IMM-233 design fidelity). A matched
// display name ("Hannelore Schmidt") reduces to first + last initial ("HS"); a bare
// address ("noreply@immoscout24.de", "p.vogel@vogel-finanz.de") reduces to the first
// two characters of its local part ("NO", "P."), mirroring the design's raw-address
// rows. Falls back to "?" for an empty value.
export function mailboxInitials(nameOrEmail: string | null): string {
  const value = (nameOrEmail ?? '').trim();

  if (value === '') return '?';

  // A bare address (no display-name whitespace): use its local part.
  if (!value.includes(' ') && value.includes('@')) {
    const localPart = value.slice(0, value.indexOf('@'));

    return (localPart.slice(0, 2) || value.slice(0, 2)).toUpperCase();
  }

  const parts = value.split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';

  return (first + last).toUpperCase() || '?';
}
